import { render, staticRenderFns } from "./vipTendency.vue?vue&type=template&id=5c2a4dab&scoped=true"
import script from "./vipTendency.vue?vue&type=script&lang=js"
export * from "./vipTendency.vue?vue&type=script&lang=js"
import style0 from "./vipTendency.vue?vue&type=style&index=0&id=5c2a4dab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2a4dab",
  null
  
)

export default component.exports